import { render } from "./BlockComments.vue?vue&type=template&id=160dce26&scoped=true"
import script from "./BlockComments.vue?vue&type=script&lang=js"
export * from "./BlockComments.vue?vue&type=script&lang=js"

import "./BlockComments.vue?vue&type=style&index=0&id=160dce26&scoped=true&lang=css"

import exportComponent from "/mnt/dados/Projects/softline-infinity-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-160dce26"]])

export default __exports__